import { US_COUNTRY_ID } from "../../../../infrastructure/context/UserContext";
import { State } from "../../../../shared/address/State";
import { getStateCode } from "../../../../utilities/AddressUtility";
import { Property } from "../../models/Property";
import { PropertyFormState } from "../models/PropertyForm.state";


export const loadPropertyFormState = (property: Property, states: State[]): PropertyFormState => {
    return {
        organization: property.organization_id,
        propertyName: property.property_name,
        propertyDescription: property.description || '',
        propertyReferenceId: property.property_reference_id || '',
        propertyTypeId: property.property_type || 0,
        accommodates: property.accommodates || 0,
        bedrooms: property.bedrooms || 0,
        bathrooms: property.bathrooms || 0,

        propertyAddressId: property.address.address_id,
        propertyAddressCountryName: property.address.country_name,
        propertyAddressCountryId: property.address.country_id || US_COUNTRY_ID,
        propertyAddressState: getStateCode(property.address.state),//states.find(state => state.value == property.address.state)?.value || '',
        propertyAddressLine1: property.address.address_line_1,
        propertyAddressLine2: property.address.address_line_2,
        propertyAddressCity: property.address.city,
        propertyAddressPostalCode: property.address.postal_code,

        ownerName: property.property_owner_name || '',
        ownerEmail: property.property_owner_email || '',
        ownerPhone: property.property_owner_phone || '',
        ownerAddressId: property.property_owner_address?.address_id || -1,
        ownerAddressCountryName: property.property_owner_address?.country_name || '',
        ownerAddressCountryId: property.property_owner_address?.country_id || 1,
        ownerAddressState: states.find(state => state.value == property.property_owner_address?.state)?.value || '',
        ownerAddressLine1: property.property_owner_address?.address_line_1 || '',
        ownerAddressLine2: property.property_owner_address?.address_line_2 || '',
        ownerAddressCity: property.property_owner_address?.city || '',
        ownerAddressPostalCode: property.property_owner_address?.postal_code || '',

        photos: property.photos?.map(photo => ({ url: photo.url, id: String(photo.photo_id) })) || [],
    };
}